module.exports = __webpack_public_path__ + "static/media/icon-instagram.41ee472d.svg";